import React, { useState } from "react";
import { Page, Tabs } from "@shopify/polaris";
import { useUser } from "context/user";
import HdsImportHistoryPage from "views/HdsImportHistoryPage/HdsImportHistoryPage";
import PosImportHistoryPage from "views/PosImportHistoryPage/PosImportHistoryPage";

const TABS = [
  { id: "hds", content: "HDS", panelID: "hds-panel" },
  { id: "pos", content: "POS (GlobePOS)", panelID: "pos-panel" },
];

export default function ImportHistoryPage() {
  const user = useUser();
  const [selectedTab, setSelectedTab] = useState(0);

  const tabs = user?.isAdmin ? TABS : [TABS[0]];

  return (
    <Page
      title="Import History"
      subtitle="Track and manage your product imports"
    >
      <Tabs tabs={tabs} selected={selectedTab} onSelect={setSelectedTab}>
        <div>
          {selectedTab === 0 && <HdsImportHistoryPage />}
          {selectedTab === 1 && user?.isAdmin && <PosImportHistoryPage />}
        </div>
      </Tabs>
    </Page>
  );
}
